// src/components/ListingRedirect.tsx
import { useEffect } from 'react';
import { useParams, useRouter } from '../components/Router';
import { supabase } from '../lib/supabase';

export function ListingRedirect() {
  const { id } = useParams<{ id: string }>();
  const { navigate } = useRouter();

  useEffect(() => {
    async function redirect() {
      try {
        if (!id) {
          navigate('/annonces');
          return;
        }

        // Check if id is a UUID
        const isUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id);
        
        // If it's NOT a UUID, it is already a slug. 
        // Redirect to the new clean URL structure /annonces/slug
        if (!isUUID) {
          navigate(`/annonces/${id}`);
          return;
        }
        
        // It IS a UUID. Try to get the slug to make the URL pretty.
        const { data, error } = await supabase
          .from('listings')
          .select('slug')
          .eq('id', id)
          .maybeSingle(); // Use maybeSingle to avoid 406 errors
        
        // If we found a slug, redirect to the pretty URL
        if (data && data.slug) {
          navigate(`/annonces/${data.slug}`);
        } else {
          // If we didn't find a slug (or error), fallback to using the ID.
          // This prevents the loop back to /annonces
          navigate(`/annonces/${id}`);
        }
      } catch (error) {
        console.error('Redirect error:', error);
        // Fallback to listings page only on catastrophic failure
        navigate('/annonces');
      }
    }

    redirect();
  }, [id, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#D4452C] mx-auto"></div>
        <p className="mt-3 text-gray-500 text-sm font-medium">Redirection...</p>
      </div>
    </div>
  );
}